interface WelcomeConfig {
  title?: string
  subtitle?: string
}

interface StepConfig {
  welcome?: WelcomeConfig
}

interface WelcomeStepProps {
  stepConfig: StepConfig
  goNext: () => void
  t: (key: string) => string
}

export default function WelcomeStep({ stepConfig, goNext, t }: WelcomeStepProps) {
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 'var(--text-display-2xl)', marginBottom: 20 }}>✨</div>
      <h1 style={{ fontSize: 'var(--text-3xl)', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 12 }}>
        {stepConfig.welcome?.title || t('welcomeToBrighella')}
      </h1>
      <p style={{ fontSize: 'var(--text-md)', color: 'var(--text-secondary)', lineHeight: 1.7, marginBottom: 36 }}>
        {stepConfig.welcome?.subtitle || t('productionAssetManagement')}
      </p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, textAlign: 'left', marginBottom: 40,
        background: 'var(--bg-elevated)', borderRadius: 12, padding: '20px 24px' }}>
        {[
          ['📦', t('allEquipmentOnePlatform')],
          ['🔎', t('neverLoseTrack')],
          ['🤝', t('smartScheduling')],
          ['📍', t('teamCollaboration')],
        ].map(([icon, text]) => (
          <div key={text} style={{ display: 'flex', gap: 12, alignItems: 'center', fontSize: 'var(--text-base)', color: 'var(--text-secondary)' }}>
            <span style={{ fontSize: 'var(--text-xl)', width: 26, textAlign: 'center' }}>{icon}</span>
            <span>{text}</span>
          </div>
        ))}
      </div>
      <button
        onClick={goNext}
        style={{
          width: '100%', padding: '14px', borderRadius: 10,
          background: 'var(--accent)', color: 'var(--text-inverse)',
          border: 'none', fontSize: 'var(--text-md)', fontWeight: 600,
          cursor: 'pointer', transition: 'opacity 0.15s',
        }}
        onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
        onMouseLeave={e => e.currentTarget.style.opacity = '1'}
      >
        {t('getStarted')}
      </button>
    </div>
  )
}
